// Storefront ecommerce events for PostHog. Initialised in snippets/posthog.liquid,
// which also captures Product Viewed on product pages.
(function () {
  const state = window.ckPosthog;
  if (!state || !window.posthog || typeof subscribe !== 'function') return;

  function whenLoaded(callback) {
    if (state.loaded) callback();
    else document.addEventListener('posthog:loaded', callback, { once: true });
  }

  // The checkout runs outside the theme, so the custom pixel reads this cart
  // attribute to attribute checkout events to the same PostHog person.
  function syncCartDistinctId() {
    const distinctId = posthog.get_distinct_id();
    if (!distinctId || distinctId === state.cartDistinctId) return;

    state.cartDistinctId = distinctId;
    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({ attributes: { [state.cartAttribute]: distinctId } }),
    }).catch(() => {
      state.cartDistinctId = null;
    });
  }

  if (state.cartItemCount > 0) whenLoaded(syncCartDistinctId);

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    // product-form's cartData is the line item returned by /cart/add.
    if (event.source !== 'product-form' || !event.cartData) return;
    const item = event.cartData;

    posthog.capture('Product Added', {
      product_id: item.product_id,
      variant_id: item.variant_id,
      sku: item.sku,
      name: item.product_title,
      variant: item.variant_title,
      category: item.product_type,
      price: item.final_price / 100,
      currency: state.currency,
    });

    whenLoaded(syncCartDistinctId);
  });
})();
